// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uKlY","top":"styles_top__2RILS","left":"styles_left__3yF5J","description":"styles_description__20ZtE"};